"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.Lanes = void 0;
var Lanes = /** @class */ (function () {
    function Lanes() {
        this.lanes = [];
    }
    Lanes.prototype.size = function () {
        return Object.keys(this.lanes).length;
    };
    Lanes.prototype.addLane = function () {
        this.lanes[this.size()] = [];
        return this.size() - 1;
    };
    Lanes.prototype.laneEnd = function (index) {
        return this.lanes[index][this.lanes[index].length - 1].right();
    };
    Lanes.prototype.findLaneEndingBefore = function (date) {
        for (var lane in Object.keys(this.lanes)) {
            if (this.laneEnd(lane).plus({ years: 5 }) < date) {
                return lane;
            }
        }
        return this.addLane();
    };
    Lanes.prototype.addObject = function (object) {
        var laneIndex = this.findLaneEndingBefore(object.left());
        this.lanes[laneIndex].push(object);
    };
    Lanes.prototype.addObjects = function (objects) {
        var _this = this;
        objects.forEach(function (it) { return _this.addObject(it); });
    };
    Lanes.prototype.getLanes = function () {
        return this.lanes;
    };
    return Lanes;
}());
exports.Lanes = Lanes;
